import { getApiErrorMessage } from "@src/shared/helpers/parseApiError";
import { useMemo } from "react";

export type QueryState<T> =
  | { data: T; status: "success" }
  | { error: unknown; messages: string[]; retry: () => void; status: "error" }
  | { status: "loading" };

type Query = {
  data: unknown;
  error: unknown;
  refetch: () => unknown;
};

export function useQueryState<Q extends Query>(
  { data, error, refetch }: Q,
  fallbackErrorMessage: string,
): QueryState<Exclude<Q["data"], undefined>> {
  return useMemo(() => {
    if (data !== undefined) {
      return { data: data as Exclude<Q["data"], undefined>, status: "success" };
    }
    if (error) {
      return {
        error,
        messages: [getApiErrorMessage(error, fallbackErrorMessage)],
        retry: () => void refetch(),
        status: "error",
      };
    }
    return { status: "loading" };
  }, [data, error, refetch, fallbackErrorMessage]);
}
